import { render, staticRenderFns } from "./payConfig.vue?vue&type=template&id=09465351&scoped=true&"
import script from "./payConfig.vue?vue&type=script&lang=js&"
export * from "./payConfig.vue?vue&type=script&lang=js&"
import style0 from "./payConfig.vue?vue&type=style&index=0&id=09465351&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09465351",
  null
  
)

export default component.exports